import React, { PureComponent } from 'react';
import { PropTypes } from 'prop-types';
import moment from 'moment';
import AccessControl from 'components/AccessControl';
import ActivityPerms from 'components/AccessControl/permissions.json';
import RedirectButton from 'components/Common/Buttons/RedirectButton';

class AccountFormList extends PureComponent {
  static propTypes = {
    onConfirmFormUnlink: PropTypes.func.isRequired,
    permissions: PropTypes.arrayOf(PropTypes.string),
    account: PropTypes.shape(),
  };

  static defaultProps = {
    permissions: null,
    account: {
      forms: []
    }
  };

  render() {
    const { permissions, account, onConfirmFormUnlink } = this.props;
    return (
      <div>
        <div>
          <table className="table table-striped table-hover table-bordered">
            <thead>
              <tr>
                <th>Account Number</th>
                <th>Account Name</th>
                <th>Form Type</th>
                <th>Date Uploaded</th>
                <th>Entity Name</th>
                <th>View/Action</th>
              </tr>
            </thead>
            <tbody>
              { (account != null && account.forms != null && account.forms.length > 0)
                && account.forms.map(formData => formData != null && <tr key={ formData.id }>
                  <td align="center">{ account.accountNumber != null ? account.accountNumber : '' }</td>
                  <td align="center">{ account.accountName != null ? account.accountName : '' }</td>
                  <td align="center">{ formData.formTypeDescription != null ? formData.formTypeDescription : '' }</td>
                  <td align="center">{ formData.dateUploaded != null ? moment(formData.dateUploaded).format('MMM DD, YYYY') : '' }</td>
                  <td>{ formData.entityName }</td>
                  <td className="form-action-btn-group">
                    {
                      (
                        (formData.isOnlineForm
                          && AccessControl.hasPermission(
                            permissions,
                            [
                              ActivityPerms.electronicView,
                              ActivityPerms.electronicValidate
                            ]
                          )
                        ) || (
                          !formData.isOnlineForm
                          && AccessControl.hasPermission(
                            permissions,
                            [
                              ActivityPerms.scannedView,
                              ActivityPerms.scannedEdit,
                              ActivityPerms.scannedValidate
                            ]
                          )
                        )
                      ) && formData.formType && formData.formType.toLowerCase() !== 'unknown' && <RedirectButton
                        to={ `/forms/${ formData.formType.toLowerCase() }/${ formData.id != null ? formData.id : '' }` }
                        title={ <span className="icon icon-apps" /> }
                        hint="Reopen"
                        className="btn btn-sm"
                      />
                    }
                    { ((formData.isOnlineForm && AccessControl.hasPermission(
                      permissions,
                      [
                        ActivityPerms.electronicDelete
                      ]
                    )
                    )
                      || (
                        !formData.isOnlineForm
                          && AccessControl.hasPermission(
                            permissions,
                            [
                              ActivityPerms.scannedDelete
                            ]
                          )
                      )
                    ) && formData.formType && formData.formType.toLowerCase() !== 'unknown' && AccessControl.hasPermission(
                      permissions,
                      [
                        ActivityPerms.accountPageEdit
                      ]
                    ) && <button
                      className="btn btn-sm btn-danger"
                      onClick={ () => onConfirmFormUnlink(formData.id) }
                      type="button"
                      title="Unlink form"
                    >
                      <span className="icon icon-link" />
                    </button> }
                  </td>
                </tr>) }
              { (!account || !account.forms || account.forms.length === 0)
                && <tr><td colSpan="7" style={ { textAlign: 'center' } }><p><b>No Data to Show</b></p></td></tr> }
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default AccountFormList;
